$(function() {
  'use strict';

  //初期実行
  //console.log(location.hash);
  if ( location.hash === '#open_comment_form=1' ) {
    showCommentForm();
  }


  function showCommentForm() {
    var user = moko.getUser();

    //フォームにユーザー情報を設定
    if ( user.name  ) {
      $('#form-input-author').val( user.name );
    }
    if ( user.id ) { 
      $('#form-input-user_id').val( user.id );
    }

    //これを設定しないと画像投稿できない 
    if ( $('#commentform')[0] ) { 
      $('#commentform')[0].encoding = 'multipart/form-data';
    }
    

    $('#comment-dummy').hide();
    $('#comment-form').show();

    $('#comment').focus();

    console.log('show comment form ',user.name, user.id );
  }

  /**
   * ダミーコメントフォームをクリックでフォーム開く
   ***/
  $('#comment-dummy').on('click touchstart',function() {
    showCommentForm();
  });


  /**
   * 返信リンクをクリックするとコメントフォームが現れる
   **/
  $('.reply-link').on('click touchstart', function() {
    showCommentForm();
  });
  $('.comment-reply-link').on('click touchstart', function() {
    showCommentForm();
  });

  /**
   * フォームを投稿する直前の処理
   **/
  $('form.comment-form').submit( function(e) {
  //$('#btn-submit').click( function(e) {
    //console.log('click submit button');

    var errors = validate();
    if ( errors.length > 0 ) {
      showErrors(errors);
      e.preventDefault();
      return;
    }

    //コメント ユーザー名を書き込む
    var user = moko.getUser();
    var comment_author = $('#form-input-author').val() || null;
    var comment_post_id = $('#comment_post_ID').val();
    var comment_parent = $('#comment_parent').val();
    var comment_url = $('#comment_url').val();
    var comment_content = $('#comment').val();
    var comment_user_id = $('#form-input-user_id').val() || null;

    if ( comment_author ) { 
      user.name = comment_author;
      moko.saveUser(user);
    }


    //メッセージを表示
    moko.showLoading();

    //アナリティクスへ送信
    var category = 'comment-post';
    var action = 'comment-post';
    var label = moko.home_url;
    var value = 1;
    var options = {};

    ga('send', 'event',  category, action, label , options );
    ga('all.send', 'event',  category, action, label , options );

    //return false;
    return true;
  });



  //- クリックで通報と削除のメニューを表示 -----------------------------------
  $('.comment-meta__menu').click(function() {
    if ($('.report-delete-set').not(this).hasClass('open')) {//自身以外でclass openがあれば
      $('.report-delete-set').not(this).removeClass('open');//それらは閉じる
    }

    $('.comment-meta__menu,.report-delete-set',this).toggleClass('open');//自身だけtoggleClass使用

    var user = moko.getUser();
    var delete_button =  $(this).find('.comment-delete');
    //console.log(user.id_hash);
    //console.log(delete_button.data('user-id-hash'));
    if ( delete_button.data('user-id-hash') === user.id_hash ) {
      delete_button.show();
    }

    initReportButton( $(this).find('.comment-report') );
  });

  // -　スライドで返信を表示 -----------------------------------
  $('.reply-meta').on('click', function() {
    $(this).next().slideToggle();
    $(this).toggleClass('open');//開閉矢印の切り替え
  });


  //選択した画像を表示する処理
  $('#article_image_file_name').on('change', function(event){
    document.getElementById('comment_attachments_list').innerHTML = '';

    var files = event.target.files;

    for ( var i = 0 ; i < files.length; i++ ) { 
      var f = files[i];
      var reader = new FileReader();
      reader.readAsDataURL(f);
      reader.onload = (function(theFile) {
        return function (e) {
          var div = document.createElement('div');
          div.className = 'reader_file';
          div.innerHTML = '<div class="reader_title">' + theFile.name + '</div>';
          div.innerHTML += '<img class="reader_image" src="' + e.target.result + '" />';
          document.getElementById('comment_attachments_list').insertBefore(div, null);
        };
      })(f);
    }
  });

  /**
   ** コメント投稿のバリデーション
   ***/
  function validate() {
    var content = $('#comment').val();
    var author = $('#form-input-author').val();
    var errors = [];
    if ( content.trim() === '' ) {
      errors.push( 'コメント本文を入力してください。');
    }
    if ( content.length > 1000 ) {
      errors.push( 'コメントは1000字以内で入力してください。');
    }
    if ( author && author.trim() === '' ) {
      errors.push( '名前を入力してください。');
    }
    if ( author && author.length > 100 ) {
      errors.push( '名前は100文字以内で入力してください。');
    }

    return errors;
  }

  /**
   ** エラーメッセージを表示
   ***/
  function showErrors(errors) {
    var message = '';
    errors.forEach( function( error ) { 
      message += '<div>'+error+'</div>';
    });
    $('#error-message').hide();
    $('#error-message').html(message);
    $('#error-message').fadeIn();
  }

  // 通報ボタン押下
  function initReportButton( $button ) { 
    if ( $button.data('event_inited') ) {
      return;
    }
    
    $button.on('click',  function(event) {
      event.preventDefault();
      var repBtn = $(this);
      repBtn.prop('disabled', true);

      var comment_id = repBtn.data('comment-id');
      var site_url =  repBtn.data('site-url');
      var nonce = repBtn.data('nonce');
      showReportForm(site_url, comment_id, nonce );
      return;


      if (!confirm('不適切なコメントとして通報してもよろしいですか？')) { 
        return false;
      }


      $.ajax({
        url: moko.ajaxurl,
        type: 'POST',
        dataType: 'text',
        timeout: 20000,
        cache : false,
        data: {
          'action': 'comment_report',
          '_ajax_nonce': repBtn.data('nonce'),
          'comment_id': repBtn.data('comment-id'),
          'site_url': repBtn.data('site-url')
        }
      }).
        always(function() {
          repBtn.prop('disabled', false);
        }).
          fail(function(xhr, status, error) {
            console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
            alert('通信エラー');
          }).
            done(function(data) {
              data = data.trim();
              //console.log(data);
              if (data === 'OK') {
                alert('コメントを通報しました');
              } else if (data === 'Existing') {
                alert('既に通報しています');
              } else {
                alert('送信に失敗しました');
              }
            });
    });
    $button.data('event_inited',1);
  }

  /**
   * 通報フォーム表示
   **/
  function showReportForm( site_url, comment_id, nonce ) {
      $('#report-site-url').val(site_url);
      $('#report-comment-id').val(comment_id);
      $('#report-nonce').val(nonce);
      $('#report-form').show();
  }

  /**
   * 通報実行
   **/
  $('#submit-report').click(function() {
      var site_url = $('#report-site-url').val();
      var comment_id = $('#report-comment-id').val();
      var reason = $('#report-reason').val();
      var nonce = $('#report-nonce').val();

      $('#report-form').hide();
      moko.showLoading(); 
      $.ajax({
        url: moko.ajaxurl,
        type: 'POST',
        dataType: 'text',
        timeout: 20000,
        cache : false,
        data: {
          'action': 'comment_report',
          '_ajax_nonce': nonce,
          'comment_id': comment_id,
          'site_url': site_url,
          'reason' : reason,
        }
      })
      .always(function() {
        moko.hideLoading();
      })
      .fail(function(xhr, status, error) {
        console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
        alert('通信エラー');
      })
      .done(function(data) {
        data = data.trim();
        console.log(data);
        alert('ご協力ありがとうございました。');
      });
  });
 

  /**
   * 通報キャンセル
   **/
  $('#cancel-report').click(function() {
      $('#report-form').hide();
  });


  /**
   * 削除ボタン
   **/
  $('.comment-delete').click(function() {
    if (!confirm('コメントを削除します。よろしいですか？')) { 
      return;
    }
 
    //メッセージを表示
    moko.showLoading(); 
    var user = moko.getUser();
    var nonce = $(this).data('nonce');
    var comment_id = $(this).data('comment-id');
    var site_url = $(this).data('site-url');
    $.ajax({
        url: moko.ajaxurl,
        type: 'POST',
        dataType: 'json',
        timeout: 20000,
        cache : false,
        data: {
          'action': 'comment_delete',
          '_ajax_nonce': nonce,
          'comment_id': comment_id,
          'site_url': site_url,
          'user_id' : user.id ,
        }
      })
      .always(function() {
        moko.hideLoading();
      })
      .fail(function(xhr, status, error) {
        console.log('failed: ' + status + ' ' + xhr.status + ' ' + xhr.statusText);
        alert('削除できませんでした。');
      })
      .done(function(data) {
        console.log(data);
        location.reload();
      });

  });

});
